import GoodsContent from './goods-content' // 商品内容
import GoodsVipForever from './goods-vip-forever' // 无限卡内容
// import GoodsVipForever2021 from './goods-vip-forever2021' // 无限卡内容
import GoodsVipForever2022 from './goods-vip-forever2022' // 2022 无限卡内容
import OrderUserbar from './order-userbar' // 页面功能

export default {
  GoodsContent,
  GoodsVipForever,
  OrderUserbar,
  GoodsVipForever2022
  // GoodsVipForever2021
}
